import { Injectable } from '@angular/core';
import { empty } from 'rxjs';

/**
 * Serviço e validação de CNPJ
 */
@Injectable({
  providedIn: 'root'
})
export class ValidaCnpjService {
  constructor() {}

  /**
   * Valida CNPJ nos formatos:
   * - Tradicional: 14 dígitos numéricos
   * - Novo: 12 alfanuméricos (maiúsculos) + 2 dígitos numéricos finais
   */
  public validarCNPJ(cnpj: string): boolean {
    cnpj = this.retirarMascara(cnpj);
    
    if (!cnpj || cnpj.length !== 14) {
      return false;
    }

    // Novo formato: 12 alfanuméricos (maiúsculos) + 2 numéricos
    const regexNovo = /^[A-Z0-9]{12}\d{2}$/;
    // Antigo: 14 numéricos
    const regexAntigo = /^\d{14}$/;

    if (regexAntigo.test(cnpj)) {
      return this.validarCNPJAntigo(cnpj);
    }

    // Força letras maiúsculas para o novo formato
    const cnpjUpper = cnpj.toUpperCase();
    if (regexNovo.test(cnpjUpper)) {
      return this.validarCNPJNovo(cnpjUpper);
    }

    return false;
  }

  /**
   * Validação tradicional de CNPJ (apenas números)
   */
  private validarCNPJAntigo(cnpj: string): boolean {
    const valida = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let dig1 = 0;
    let dig2 = 0;

    const digito = cnpj.charAt(12) + cnpj.charAt(13);

    // Use forNext se disponível, senão use for tradicional
    for (let i = 0; i < valida.length; i++) {
      if (i > 0) {
        dig1 += Number(cnpj.charAt(i - 1)) * valida[i];
      }
      dig2 += Number(cnpj.charAt(i)) * valida[i];
    }

    dig1 = dig1 % 11 < 2 ? 0 : 11 - (dig1 % 11);
    dig2 = dig2 % 11 < 2 ? 0 : 11 - (dig2 % 11);

    return dig1 * 10 + dig2 === Number(digito);
  }

  /**
   * Validação do novo formato de CNPJ (12 alfanuméricos + 2 numéricos)
   * Apenas verifica o padrão, pois não há algoritmo público para letras.
   */
  private validarCNPJNovo(cnpj: string): boolean {
    // Apenas valida o padrão: 12 alfanuméricos maiúsculos + 2 numéricos
    return true;
  }

  public retirarMascara(cnpj: string): string {
    if (cnpj !== null && cnpj !== undefined && cnpj !== '') {
      const exp = /\.|\-|\//g;
      cnpj = cnpj.toString().replace(exp, '');
      return cnpj;
    } else {
      return null;
    }
  }

  aplicarMascaraNumerica(valor: any): string {
    return valor;
  }

  aplicarMascara(valor: any, regex: any) {
    let novoValor = '';
    for (let i = 0; i < valor.length; i++) {
      const aux = valor[i].replace(regex, '');
      novoValor += aux;
    }
    return novoValor;
  }
}